import CONFIG from "./../config.json";
import {cacheGetCacheTime} from "./cache.js";
import {mapsTown, mapsLabel} from "./maps.js";
import {postersEscapeSpacesAndApostrophes} from "./posters.js";
import {Log} from "./log.js";


let tagsTopLabels = ["Festa", "Fira", "Esport", "Música", "Cinema", "Teatre", "Per nens"];

function tagsDynamicFetch()
{
    return new Promise(function (resolve, reject)
    {
        let resource = `${CONFIG.posters_api_url}/resource/poster/public/tagsnumber`;

        const cacheTime = cacheGetCacheTime();
        if ((cacheTime !== null) && (cacheTime !== ""))
        {
            resource += "?cacheTime=" + cacheTime;
        }

        fetch(resource)
                .then(response => response.json())
                .then(aux =>
                {
                    tagsDynamicCreateAndAppend(aux);
                    tagsDynamicMapLegendCreateAndAppend(aux);
                    resolve(true);
                })
                .catch(err =>
                {
                    Log.print("Tag dynamic fetch error: " + err);
                    reject(err);
                });
    });
}

function tagsDynamicCreateAndAppend(tagsJson)
{
    const dynamicTags = document.getElementById('dynamicTags');
    if (dynamicTags !== null)
    {

        const allTags = [
            ...Object.entries(tagsJson.towns).map(([tag, count]) => [tag, count, "town"]),
            ...Object.entries(tagsJson.labels).map(([tag, count]) => [tag, count, "label"])
        ];

        if (allTags.length > 10)
        {
            // Find the top 10 tags by count
            const topTags = allTags
                    .sort((a, b) => b[1] - a[1])
                    .slice(0, 10);

            const htmlTags = topTags.map(entry =>
            {
                const label = entry[0];
                const path = (entry[2] === 'town') ? mapsTown(null, label) : mapsLabel(null, label);
                // const url = ;
                return `<a class="mainLabels" href="${path}">${label}</a>`;
            });

            dynamicTags.innerHTML = htmlTags.join("\n");
        }

    }
}

function tagsDynamicMapLegendCreateAndAppend(tagsJson)
{
    const dynamicLegen = document.getElementById('mapLegendLabels');
    if (dynamicLegen !== null)
    {
        const tags = Object.entries(tagsJson.labels);

        if (tags.length >= 7)
        {
            tagsTopLabels = tags.sort((a, b) => b[1] - a[1])
                    .slice(0, 7)
                    .map(entry => entry[0]);

            const htmlTags = tagsTopLabels.map((label, index) =>
            {
                const scapedLabel = postersEscapeSpacesAndApostrophes(label);
                const labelClass = `map${index + 1}`;
                return `
                    <span class="mapLabels">
                        <input 
                            name="labelFilter" 
                            type="radio" 
                            onchange="mapRadioLabelFilterChange(event)" 
                            value="${label}"
                    >
                    ${label}
                    <span class="${labelClass}"></span>
                    </span>
                    `;
            });

            htmlTags[7] = `<span class="mapLabels">
                            <input 
                                name="labelFilter" 
                                type="radio" 
                                onchange="mapRadioLabelFilterChange(event)" 
                                value="" 
                                checked="checked">
                                Tots
                                <span class="mapAltres"></span>
                            </span>
                          `;


            dynamicLegen.innerHTML = htmlTags.join("\n");
        }
    }
}

export {tagsDynamicFetch, tagsTopLabels};



